import type { SharingFormData } from './useSharingForm';

export type SharingCampaign = {
  uuid: string;
  strongCriteria: {
    id: number;
    type: string;
  };
};

export type SharingTouchpointOption = {
  label: string;
  value: number;
};

export const buildSharingPayload = (params: {
  formData: SharingFormData;
  campaign: SharingCampaign;
  helperId: number;
  shareId: string;
  desiredTouchpoints: SharingTouchpointOption[];
}) => {
  const {
 formData, campaign, helperId, shareId, desiredTouchpoints, 
} = params;
  const criteria = formData.signUp.criteria;

  if (criteria === null) return null;

  const objectKey = Array.isArray(criteria) ? 'answerKeys' : 'answerKey';

  const prospectTouchPoints = desiredTouchpoints
    .map((touchpoint) => {
      const value = formData.signUp.touchpoints[touchpoint.label];

      if (!value) {
        return null;
      }

      return {
        touchPointId: Number(touchpoint.value),
        value,
      };
    })
    .filter((touchPoint) => touchPoint !== null) as {
    touchPointId: number;
    value: string;
  }[];

  return {
    campaignUuid: campaign.uuid,
    helperId,
    shareId,
    firstname: formData.signUp.firstname,
    lastname: formData.signUp.lastname,
    email: formData.signUp.email,
    phoneNumber: formData.signUp.phoneNumber,
    strongProspectCriteria: {
      criteriaId: campaign.strongCriteria.id,
      [objectKey]: criteria,
    },
    prospectTouchPoints,
  };
};
